import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scroll behaviour on client-side navigation: go to the "#anchor" when there is one, otherwise to the top.
 * Replaces React Router's <ScrollRestoration>, which injects an inline <script> into pre-rendered HTML
 * (blocked by the Content-Security-Policy, see public/_headers).
 */
export function useScrollOnNavigate() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      const target = hash ? document.getElementById(hash.slice(1)) : null;
      if (target) target.scrollIntoView();
      else window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(frame);
  }, [hash, pathname]);
}
